module.exports = __webpack_public_path__ + "img/i_o_my_like.dac1a318.svg";